/* @flow */
/** @jsx h */
import { h, VNode } from 'preact';
import cssStyles from './index.css';
import classNames from 'classnames';
import { hexToRGBA } from '../../js/colors';

type Props = {
  remainingTime: number;
  backgroundColor: string;
  backgroundOpacity: number;
  labelColor: string;
  labelOpacity: number;
  xPosition: string;
};

export default function CountdownTimer(props: Props) {
  const remainingMinutes = Math.trunc(props.remainingTime / 60);
  const remainingSeconds = Math.ceil(props.remainingTime % 60);

  if (remainingMinutes <= 0 && remainingSeconds <= 0) return null;

  let containerStyle: h.JSX.CSSProperties = {
    background: hexToRGBA(
      props.backgroundColor,
      props.backgroundOpacity
    ) as string,
    color: hexToRGBA(props.labelColor, props.labelOpacity) as string
  };

  // if vast icon is activated, it will be display on top right of the video area
  // so we need to move the countdown to the left
  if (props.xPosition === 'left') {
    containerStyle = {
      ...containerStyle,
      left: '8px',
      right: 'auto'
    };
  }

  return (
    <div
      className={classNames('countdown-timer', cssStyles.countdownTimer)}
      style={containerStyle}
    >
      {remainingMinutes}:
      {remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds}
    </div>
  );
}
